module.exports = __webpack_public_path__ + "static/media/HOMEPAGE_STORE_LOCATOR.6e0bb1a3.svg";